"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
const themes_1 = require("../themes");
/**
 * This object is DEPRECATED in favour of the theme objects
 * jest ignores this file when testing coverage
 */
exports.colors = {
    light: Object.assign({}, themes_1.lightTheme.colors),
    dark: Object.assign({}, themes_1.darkTheme.colors),
};
//# sourceMappingURL=colors.js.map